import LogsDownloadsRPIsCards from "./LogsDownloadsRPIsCards";

export default LogsDownloadsRPIsCards;